import { clearCallTimeout } from '../../../core/functions/timeoutManager';

export const callRequestCancel = async (data, reducers, WSConnection) => {
  const { placeId, pointId, userId, userDevice } = data;
  // const { notificationDispatch } = reducers;
  const newMessage = JSON.stringify({
    type: 'CALL_CANCEL',
    payload: { placeId, userId, pointId, userDevice },
  });
  try {
    await WSConnection.send(newMessage);
  } catch (error) {
    console.error('Could not send call');
  }

  try {
    clearCallTimeout('pending', userId);
  } catch (error) {
    console.error('CANNOT CLOSE CALL!');
  }
};
